// @flow

import styled, { css } from 'styled-components';
import { inPixels } from '../commons/media-size';

export const Hr = styled.div`
  margin: ${props => props.size != null ? props.size * 1.2 : 1.2}em;
  height: 1px;

  ${props => props.lined && css`
    background: ${props => props.theme.colors.gray(95)};
  `}

  ${props => props.from && css`
    display: block;
    @media (max-width: calc(${inPixels(props.from)}px - 1px)) {
      display: none;
    }
  `}

  ${props => props.to && css`
    display: block;
    @media (min-width: ${inPixels(props.to)}px) {
      display: none;
    }
  `}
`;
